import React, { Component } from "react";
import { TableHeaderColumn } from "/src/component/table/BootstrapTable";
import { withRouter } from "react-router-dom";

import EntityTable from "../../component/EntityTable";
import { TAKS_LIST } from "../../config/lang";

import { dateEnd, supervisorName, merchandiserName, point, taskStatus, createdByInfo } from "../../util/formatter";
import { translate } from "../../util/util";

import "./style.scss";

class TaskList extends Component {
  openRow = row => {
    const url = `/task/${row.id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  render() {
    const lang = this.props.currentUser.language;
    return (
      <div className="container-fluid task-list task-page">
        <div className="box p-4 task-page-list">
          <EntityTable entity="task" pagination={true} openVisitFn={this.openRow} rowClassName="task-row-item">
            <TableHeaderColumn dataField="id" isKey hidden></TableHeaderColumn>
            <TableHeaderColumn dataFormat={point} width="300px">
              {translate(TAKS_LIST, "point", lang)}
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={createdByInfo}>{translate(TAKS_LIST, "created_by", lang)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={supervisorName}>{translate(TAKS_LIST, "supervisor", lang)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={merchandiserName}>{translate(TAKS_LIST, "merchendiser", lang)}</TableHeaderColumn>
            <TableHeaderColumn dataField="title" width="200px">
              {translate(TAKS_LIST, "name", lang)}
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateEnd}>{translate(TAKS_LIST, "finishing", lang)}</TableHeaderColumn>
            <TableHeaderColumn dataFormat={taskStatus}>{translate(TAKS_LIST, "status", lang)}</TableHeaderColumn>
          </EntityTable>
        </div>
      </div>
    );
  }
}

const TaskListWithRouter = withRouter(TaskList);
export { TaskListWithRouter as TaskList };
